import { render } from "./News.vue?vue&type=template&id=799d0c0b&scoped=true"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"

import "./News.vue?vue&type=style&index=0&id=799d0c0b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-799d0c0b"

export default script